module.exports = __webpack_public_path__ + "img/FONDOPANTTJ01.bba2b4d9.png";